import { environment as workforceEnvironment } from '../../environments/environment';
import { MenuItem } from './menu.item.model';

export interface ManagerMenuSection {
  title: string;
  items: MenuItem[];
}

export const sections: ManagerMenuSection[] = [
  ...workforceEnvironment.firebase.projectId === 'isoharja-demo'
    ? [
        {
          title: 'workforceV2.beta',
          items: [
            {icon:'people', name:'nav-item.workforce.personnel', route:'/users', exact:true},
            {
              icon: 'people-outline',
              name: 'workforceV2.requirements',
              route: '/workforce-v2/requirements',
              exact: true,
            },
            {icon:'time-outline', name:'nav-item.workforce.shifts', route:'/users/shifts', exact:true},
            {
              icon: 'people-outline',
              name: 'workforceV2.work-days',
              route: '/workforce-v2/work-days',
              exact: true,
            },
            {
              icon: 'people-outline',
              name: 'workforceV2.review',
              route: '/workforce-v2/review',
              exact: true,
            },
            {
              icon: 'people-outline',
              name: 'workforceV2.customer-approvals',
              route: '/workforce-v2/customer-approvals',
              exact: true,
            },
            {
              icon: 'people-outline',
              name: 'workforceV2.payment-milestones',
              route: '/workforce-v2/payment-milestones',
              exact: true,
            },
          ],
        },
      ]
    : [],
  {
    title: 'nav-item.operational.home',
    items: [{ icon: 'home', name: 'nav.home', route: '/home' }],
  },
  {
    title: 'nav-item.operational.title',
    items: [
      { icon: 'reader-outline', name: 'nav.tasks', route: '/manager/tasks' },
      {
        icon: 'create-circle',
        name: 'nav.documents',
        route: '/manager/documents',
      },
      {
        icon: 'briefcase-outline',
        name: 'nav.projects',
        route: '/manager/projects',
      },
    ],
  },
  {
    title: 'nav-item.system.title',
    items: [
      { icon: 'apps-outline', name: 'general.more', route: '/manager/menu' },
    ],
  },
  {
    title: 'nav-item.support.title',
    items: [
      {
        icon: 'help-circle-outline',
        name: 'nav-item.support.help',
        route: '/support',
      },
    ],
  },
];

export const items: MenuItem[] = sections.flatMap((section) => section.items);

export const managerMenu = {
  sections,
  items,
};
